let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("diVkb")).then(() => parcelRequire('fyJ0C'));